/* eslint-disable @typescript-eslint/ban-ts-comment */

import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import parse from 'html-react-parser';

const TemplateOverview = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const templateData = location.state ? location.state.template : null;

  const { id: templateId } = useParams();
  const navigate = useNavigate();
  return (
    <>
      <div className="flex flex-col items-center">
        <div className="position: relative mb-8">
          <div className="h-full overflow-auto bg-darkBlue rounded-lg p-4 items-center [&::-webkit-scrollbar]:h-1 [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-track]:bg-gray-200 [&::-webkit-scrollbar-thumb]:bg-gray-600">
            {parse(templateData.content)}
          </div>
        </div>
      </div>
    </>
  );
};

export default TemplateOverview;
